<h3>Token Details</h3>
<div class="table-responsive">
  <table class="table table-striped table-hover" *ngIf="tokenDetails.siteEnabled">
    <thead>
      <tr>
        <th>Type</th>
        <th>Licences Available</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <th>Site Licences</th>
        <td>{{ tokenDetails.siteLicences }}</td>
      </tr>
    </tbody>
  </table>

  <table class="table table-striped table-hover" *ngIf="!tokenDetails.siteEnabled">
    <thead>
      <tr>
        <th>Type</th>
        <th>Tokens Purchased</th>
        <th>Tokens Available</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="tokenDetails.cloneTokens">
        <th>Full Tokens</th>
        <td>{{ tokenDetails.cloneTokens?.total }}</td>
        <td>{{ tokenDetails.cloneTokens?.available }}</td>
      </tr>
      <tr *ngIf="tokenDetails.hostTokens">
        <th>Host Tokens</th>
        <td>{{ tokenDetails.hostTokens?.total }}</td>
        <td>{{ tokenDetails.hostTokens?.available }}</td>
      </tr>
      <tr *ngIf="tokenDetails.upgradeTokens">
        <th>Upgrade Tokens</th>
        <td>{{ tokenDetails.upgradeTokens?.total }}</td>
        <td>{{ tokenDetails.upgradeTokens?.available }}</td>
      </tr>
      <tr *ngIf="tokenDetails.stagingTokens">
        <th>Staging Upgrade Tokens</th>
        <td>{{ tokenDetails.stagingTokens?.total }}</td>
        <td>{{ tokenDetails.stagingTokens?.available }}</td>
      </tr>
      <tr *ngIf="tokenDetails.raTokens && !(tokenDetails.raBulkTokens?.available > 0)">
        <th>Recovery Assurance Tokens</th>
        <td>{{ tokenDetails.raTokens?.total }}</td>
        <td>{{ tokenDetails.raTokens?.available }}</td>
      </tr>
      <tr *ngIf="tokenDetails.raBulkTokens">
        <th>Recovery Assurance Unlimited</th>
        <td colspan="2">
          Unlimited tokens {{ tokenDetails.raBulkTokens?.available > 0 ? 'enabled' : 'disabled' }}
        </td>
      </tr>
      <tr *ngIf="tokenDetails.capacity">
        <th>Capacity (TB)</th>
        <td>{{ tokenDetails.capacity?.total }}</td>
        <td>{{ tokenDetails.capacity?.available }}</td>
      </tr>
    </tbody>
  </table>
</div>
